require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-strategy-and-planning.json") })
        }
      }, "path---authors-strategy-and-planning");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-strategy-and-planning!./.cache/json/authors-strategy-and-planning.json
// module id = 1342
// module chunks = 231608221292675